import React, { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { _axios } from '../../plugins/axios';
import { URL } from '../../constants/constant';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './carousel.module.css';

const CarouselContainer = ({ pageId, onDataLoaded, dataLoaded }) => {
  const [items, setItems] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fetchError, setFetchError] = useState(false);
  const [animateSlide, setAnimateSlide] = useState(false);

  // widget framework call
  // useEffect(() => {
  //   const apiURL = `${URL.REACT_APP_API_BANNERS}/pageConfiguration/${pageId}`;

  //   _axios.get(apiURL)
  //     .then((response) => {
  //       setItems(response.data);
  //       fadeInSlideshow();
  //       onDataLoaded();
  //     })
  //     .catch((error) => {
  //       setFetchError(true);
  //     });
  // }, []);

  const fadeInSlideshow = () => {
    setTimeout(() => {
      setAnimateSlide(true);
    }, 100);
  };

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const handleItemClick = (url) => {
    if (url) {
      window.location.href = url;
    }
  };

  if (!dataLoaded || fetchError) {
    return null;
  }

  if (items?.success && items.pageId === "phelbo_home_page") {
    const allSubWidget = items.widgets?.[0]?.subWidgets;
    const carouselInterval = items.widgets?.[0]?.properties?.carouselProps?.scrollDelay;

    if (allSubWidget && allSubWidget.length > 0) {
      return (
        <div className={`${styles.carouselContainer} ${animateSlide ? styles.slideDown : ''}`}>
          <Carousel
            activeIndex={activeIndex}
            onSelect={handleSelect}
            indicators={false}
            controls={false}
            interval={carouselInterval}
          >
            {allSubWidget.map((widget, index) => (
              <Carousel.Item key={index} onClick={() => handleItemClick(widget?.properties?.onClick?.value)}>
                <img
                  src={widget?.properties?.content?.data}
                  alt={`Slide ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '150px',
                    objectFit: 'contain',
                    borderRadius: '8px',
                  }}
                />
              </Carousel.Item>
            ))}
          </Carousel>
          <div className={styles.carouselIndicators}>
            {allSubWidget.map((_, index) => (
              <span
                key={index}
                className={`${styles.indicator} ${index === activeIndex ? styles.activeIndicator : ''}`}
                onClick={() => handleSelect(index)}
              ></span>
            ))}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <h1>No banners found.</h1>
        </div>
      );
    }
  }

  return null;
};

export default CarouselContainer;